// Shared constants for ChargeRule components

export const RULE_SCOPE_FIELDS = [
  "carrierType",
  "carrierEquipmentTypeId",
  "reloadYardCommodityId", // load type
  "areaId",
  "zoneId",
];

// Where a storage report row's billing came from. A row carrying one of these
// is synthetic: it was built from something other than an Inventory record
// (a leased zone, a SIT railcar), so there is no inventory behind it to open.
export const BillingSource = {
  LEASED_ZONE: "LEASED_ZONE",
  SIT_SHIPMENT: "SIT_SHIPMENT",
};

export const ChargeEvent = {
  INBOUND: "INBOUND",
  OUTBOUND: "OUTBOUND",
  STORAGE: "STORAGE",
};

export const ChargeEventChoices = [
  { id: ChargeEvent.INBOUND, name: "Inbound" },
  { id: ChargeEvent.OUTBOUND, name: "Outbound" },
  { id: ChargeEvent.STORAGE, name: "Storage" },
  // { id: "WORK_ORDER", name: "Work Order" },
];

export const StorageFrequency = {
  MONTHLY: "MONTHLY",
  BIWEEKLY: "BIWEEKLY",
  WEEKLY: "WEEKLY",
  ON_RELEASE: "ON_RELEASE",
  ON_PULL: "ON_PULL",
  ON_DEPLETION: "ON_DEPLETION",
};

export const StorageFrequencyChoices = [
  { id: StorageFrequency.MONTHLY, name: "Monthly" },
  { id: StorageFrequency.BIWEEKLY, name: "Biweekly" },
  { id: StorageFrequency.WEEKLY, name: "Weekly" },
  { id: StorageFrequency.ON_RELEASE, name: "On Release" },
  { id: StorageFrequency.ON_PULL, name: "On Pull" },
  { id: StorageFrequency.ON_DEPLETION, name: "On Depletion" },
];

export const FeeAccrual = {
  FLAT_RATE: "FLAT_RATE",
  FLAT_ONHAND: "FLAT_ONHAND",
  PRORATED_DAILY: "PRORATED_DAILY", // prorated, per-day pricing
};

export const FeeAccrualChoices = [
  { id: FeeAccrual.FLAT_RATE, name: "Flat Rate" },
  { id: FeeAccrual.FLAT_ONHAND, name: "Flat Rate, On-Hand only" },
  { id: FeeAccrual.PRORATED_DAILY, name: "Prorated (Daily)" },
];

// Free days handling policy for storage billing
export const FreeDaysPolicy = {
  DAYS: "DAYS", // use numeric freeDays from the rule
  END_OF_MONTH: "END_OF_MONTH", // dynamic: free until end of the delivery month
};

export const FreeDaysPolicyChoices = [
  { id: FreeDaysPolicy.DAYS, name: "Days" },
  { id: FreeDaysPolicy.END_OF_MONTH, name: "End of Month (EOM)" },
];

export const BillingAutomation = {
  MANUAL: "MANUAL",
  AUTO: "AUTO",
  CUSTOM: "CUSTOM",
};

export const BillingAutomationChoices = [
  {
    id: BillingAutomation.MANUAL,
    name: "Manual",
    note: "Manually add to shipment to be invoiced.",
  },
  {
    id: BillingAutomation.AUTO,
    name: "Auto",
    note: "Auto-bill on invoice creation.",
  },
  {
    id: BillingAutomation.CUSTOM,
    name: "Custom",
    note: "Custom billing logic - contact support@transloads.co",
  },
];
